import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import {
	calculateGptValue,
	calculateMarginPlusOh,
	calculateMarginPlusOhValue,
	calculateTansportChargesValue,
	calculateTotalRow,
	calculateWastagePercentValue,
	checkForTotalColumn,
	checkForValueAddTotalColumn,
	defaultTotalRow,
	tableRowTypes,
	tableColumns,
	calculateCostBeforeDiscounting,
	calculateCostAfterDiscountingRow,
} from "./data";
import { defaultTotalRow as garmentDefTotalRow } from "../GarmentTotalTable/data";
import { Button, Checkbox, IconButton, Typography } from "@mui/material";
import { AddRounded, DeleteRounded, EditRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
	annualDiscountingPercentCol,
	applyDiscountingCol,
	DisabledBox,
	paymentTermColumn,
	TotalBox,
	totalQtyColumn,
	WhiteBgBox,
} from "../data";
import { datatypes, inputTypes } from "data/globalData";
import { GlobalState } from "context/GlobalContext";
import RenderAttributeInputs from "components/PimDashboard/CommonComponents/RenderAttributeInputs/RenderAttributeInputs";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
import { after } from "lodash";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

const PoCostTable = ({
	rows,
	setRows,
	finalTotalObj,
	optionDetails,
	setOptionDetails,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();
	const defTableColumns = [
		{
			...colStyle,
			...tableColumns.cost_type,
			headerName: tableColumns.cost_type.name,
			field: tableColumns.cost_type.key,
			renderCell: ({ field, row }) => {
				return <DisabledBox field={field} row={row} />;
			},
			minWidth: 160,
		},
		{
			...colStyle,
			...tableColumns.annual_discounting_percent,
			headerName: tableColumns.annual_discounting_percent.name,
			field: tableColumns.annual_discounting_percent.key,
			editable: true,
			renderCell: ({ field, row }) => {
				if (row.cost_type === tableRowTypes.before_discounting.key) return <DisabledBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			...tableColumns.discounting_days,
			headerName: tableColumns.discounting_days.name,
			field: tableColumns.discounting_days.key,
			editable: true,
			renderCell: ({ field, row }) => {
				if (row.cost_type === tableRowTypes.before_discounting.key) return <DisabledBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			...tableColumns.transit_plus_grn,
			headerName: tableColumns.transit_plus_grn.name,
			field: tableColumns.transit_plus_grn.key,
			editable: true,

			renderCell: ({ field, row }) => {
				if (row.cost_type === tableRowTypes.before_discounting.key) return <DisabledBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			...tableColumns.no_of_days,
			headerName: tableColumns.no_of_days.name,
			field: tableColumns.no_of_days.key,
			renderCell: ({ field, row }) => {
				return <DisabledBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			editable: true,
			...tableColumns.discount_percent,
			headerName: tableColumns.discount_percent.name,
			field: tableColumns.discount_percent.key,
			renderCell: ({ field, row }) => {
				return <DisabledBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			...tableColumns.value,
			headerName: tableColumns.value.name,
			field: tableColumns.value.key,
			renderCell: ({ field, row }) => {
				return <DisabledBox field={field} row={row} />;
			},
		},
	];

	const [tableColumnsState, setTableColumnsState] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [optionDetailsCopy, setOptionDetailsCopy] = useState(optionDetails ? optionDetails : {});

	const calculateRowValue = (row) => {
		if (row?.cost_type === tableRowTypes.after_discounting.key)
			return { ...calculateCostAfterDiscountingRow(row, finalTotalObj.value) };
		if (row?.cost_type === tableRowTypes.before_discounting.key)
			return { ...calculateCostBeforeDiscounting(row, finalTotalObj.value) };

		return { ...row, is_updated: true, last_updated_by: user.email };
	};

	useEffect(() => {
		setTableColumnsState([
			...defTableColumns,
			//  deleteTableColumn(handleDeleteRowClick, (row) => checkForTotalColumn(row))
		]);
	}, []);
	useEffect(() => {
		if (finalTotalObj?.value > 0) {
			setRows((prev) => {
				return prev.map((row) => {
					return calculateRowValue(row);
				});
			});
		}
	}, [finalTotalObj?.value, optionDetails?.[totalQtyColumn.key]]);

	const processRowUpdate = (newRow, oldRow) => {
		try {
			let correct = true;
			// checking for NAN Values
			Object.values(tableColumns)?.forEach((col) => {
				if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
					if (isNaN(newRow[col.key])) correct = false;
			});
			if (correct) {
				let updatedNewRow = calculateRowValue(newRow);
				setRows((prev) => {
					let newRows = prev.map((row) => {
						if (row.id === updatedNewRow.id) return { ...updatedNewRow, is_updated: true, last_updated_by: user.email };
						else return row;
					});
					return newRows;
				});
				return updatedNewRow;
			} else {
				setSnackBar({
					...snackBar,
					message: "Please Enter Proper Values",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setSnackBarOpen(true);
			}
		} catch (error) {
			console.log(error, "sabdasmdbas");
		}
	};

	const handleDiscountingCheckbox = (e) => {
		setOptionDetails({ ...optionDetails, [applyDiscountingCol.key]: e.target.checked ? "YES" : "NO" });
		if (!e.target.checked) {
			// remove discounting rows
			setRows((prev) => {
				const { id, cost_type, ...restBeforeDiscounting } = prev.filter(
					(row) => row.cost_type === tableRowTypes.before_discounting.key
				)[0];
				const afterDiscountingRow = prev.filter((row) => row.cost_type === tableRowTypes.after_discounting.key)[0];
				return [
					{ id, cost_type, ...restBeforeDiscounting },
					{ ...afterDiscountingRow, ...restBeforeDiscounting, is_updated: true, last_updated_by: user.email },
				];
			});
		}
	};

	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setOptionDetails(optionDetailsCopy);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
		setOptionDetailsCopy(optionDetails);
		setRowsCopy(rows);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, []);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setOptionDetailsCopy(optionDetails);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	return (
		<Box>
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6"> PO Cost </Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<></>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>{" "}
			<Box display="flex" alignItems="center">
				<RenderAttributeInputs
					columns={[
						{
							...paymentTermColumn,
							input_type: mode === "create" || editMode ? inputTypes.ENTER.key : inputTypes.AUTO_GENERATE.key,
						},
					]}
					setData={setOptionDetails}
					data={optionDetails}
					selectOptObjOptName={""}
					inputWidth="100%"
					width="30%"
				/>
				<Typography variant="h6" fontWeight={400}>
					Final PO Cost : <span style={{ fontWeight: "bold" }}>{roundDecimalValueUptoTwoDigit(rows?.[1]?.value) ?? 0} </span>{" "}
				</Typography>
			</Box>
			<Box display="flex" columnGap="5px" alignItems="center">
				<Checkbox
					checked={optionDetails?.discounting_applied === "YES" ? true : false}
					onChange={handleDiscountingCheckbox}
					disabled={mode === "create" || editMode ? false : true}
				/>
				<Typography variant="body1">Apply Discounting</Typography>
			</Box>
			{optionDetails?.discounting_applied === "YES" && (
				<Box width="100%">
					<DataGrid
						rows={[...(rows || [])]}
						getRowId={(row) => row.cost_type + "_" + row.value}
						columns={tableColumnsState}
						sx={{
							width: "100%",
							"& .MuiDataGrid-row": {
								cursor: "pointer",
							},
							"& .MuiDataGrid-row:hover": {
								backgroundColor: "transparent",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								background: grey[400],
								textTransform: "uppercase",
							},
							"& .MuiDataGrid-cell": {
								padding: 0,
							},
						}}
						disableRowSelectionOnClick
						pagination={false} // Remove footer
						hideFooter={true}
						showCellVerticalBorder
						showColumnVerticalBorder
						density="compact"
						isCellEditable={({ row }) =>
							row.cost_type !== tableRowTypes.before_discounting.key && (mode === "create" || editMode)
						}
						processRowUpdate={processRowUpdate}
						autoHeight
						disableColumnSorting
						disableColumnFilter
						disableColumnMenu
					/>
				</Box>
			)}
		</Box>
	);
};

export default PoCostTable;
